import React from 'react'
import BaseIcon from './BaseIcon'
import img from 'assets/img/ic-down.png'

const ArrowDownIcon = (props: any) => {
  return <BaseIcon img={img} onClick={props.onClick} />
}

export default ArrowDownIcon
